/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { TrecApiError, TrecError } from "@trec/api/errors";
import { CreateMeetingReqv3, Meeting } from "@trec/api/video-chat";
import { ErrorAction, StoreAction } from "@trec/components/store";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace VideoMeetingActions {
  export class FetchMeetings extends StoreAction {
    static readonly type = "[Video Meeting] Fetch meetings";
    constructor(
      public payload: {
        isPhysician: boolean | undefined;
        idStruttura: string | null;
        idUserTrec: string | null;
        skipCreatorPersonalData?: boolean | undefined;
        idPaziente?: string | null;
        history?: boolean | undefined;
      },
    ) {
      super();
    }
  }

  export class SetMeetings extends StoreAction {
    static readonly type = "[Video Meeting] Set meetings";

    constructor(public payload: { meetings: Meeting[] }) {
      super();
    }
  }

  export class CreateMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Create meeting";

    constructor(
      public payload: {
        meeting: CreateMeetingReqv3;
        isPhysician: boolean | undefined;
        idStruttura: string | null;
        idUserTrec: string | null;
        skipCreatorPersonalData?: boolean | undefined;
        idPaziente?: string | null;
      },
    ) {
      super();
    }
  }

  export class CreateDirectMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Create direct meeting";

    constructor(
      public payload: { patientId: string; idStruttura: string | null; patientName: string },
    ) {
      super();
    }
  }
  export class StartMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Start meeting";

    constructor(public payload: { meetingId: string }) {
      super();
    }
  }

  export class EndMeeting extends StoreAction {
    static readonly type = "[Video Meeting] End meeting";

    constructor(public payload: { meetingId: string }) {
      super();
    }
  }

  export class FetchCurrentMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Fetch current meeting";

    constructor(public payload: { meetingId: string }) {
      super();
    }
  }

  export class SetCurrentMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Set current meeting";

    constructor(public payload: { meeting: Meeting | null }) {
      super();
    }
  }

  export class CancelMeeting extends StoreAction {
    static readonly type = "[Video Meeting] Cancel meeting";

    constructor(public payload: { meetingId: string }) {
      super();
    }
  }

  export class Error extends ErrorAction {
    static readonly type = "[Video Meeting] Error";
    readonly error = true;

    readonly errorMsgs = {
      meeting_not_found:
        "Non è stata trovata alcuna videochiamata. Assicurarsi che il link sia corretto",
      invalid_startTime: `La data o l'orario della videochiamata non sembrano essere corretti. Per favore, ricontrolla i dati inseriti`,
      cannot_cancel_old_meeting: `Non è possibile cancellare una videochiamata precedentemente iniziata`,
      invalid_participant: `Il paziente scelto non esiste (o è attualmente disabilitato). Per favore, ricontrolla i dati immessi`,
    };

    constructor(public payload: TrecApiError | TrecError) {
      super();
    }
  }
}
